import { ReactComponent as NewApplicationsIcon } from 'assets/icons/bag-2.svg'
import { ReactComponent as EssaysReviewIcon } from 'assets/icons/dock_article.svg'
import { ReactComponent as FeedbackRepliesIcon } from 'assets/icons/message-dots.svg'
import { ReactComponent as DocumentsUploadedIcon } from 'assets/icons/folder_shared.svg'
import { ReactComponent as LorRequestsIcon } from 'assets/icons/badge.svg'
import { ReactComponent as UploadedLorIcon } from 'assets/icons/upload.svg'
import { ReactComponent as AssignmentUpdatesIcon } from 'assets/icons/assignment-2.svg'
import { ReactComponent as StudentMessagesIcon } from 'assets/icons/mail.svg'

export const NOTIFICATION_OPTIONS = [
	{
		id: 'newApplications',
		icon: NewApplicationsIcon,
		tone: 'purple',
		title: 'New applications',
		text: "When a new application is added to your students' shortlist.",
	},
	{
		id: 'essays',
		icon: EssaysReviewIcon,
		tone: 'orange',
		title: 'Essays waiting review',
		text: 'When a student submits an essay for your review.',
	},
	{
		id: 'feedback',
		icon: FeedbackRepliesIcon,
		tone: 'green',
		title: 'Feedback replies',
		text: 'When students reply to your essay feedback.',
	},
	{
		id: 'documents',
		icon: DocumentsUploadedIcon,
		tone: 'blue',
		title: 'Documents uploaded',
		text: 'When students upload new application documents or brag sheets.',
	},
	{
		id: 'lorRequests',
		icon: LorRequestsIcon,
		tone: 'yellow',
		title: 'LoR requests',
		text: 'When a student requests a letter of recommendation.',
	},
	{
		id: 'lorUploaded',
		icon: UploadedLorIcon,
		tone: 'teal',
		title: 'Uploaded LoR',
		text: 'When a letter of recommendation is uploaded.',
	},
	{
		id: 'assignments',
		icon: AssignmentUpdatesIcon,
		tone: 'rose',
		title: 'Assignment updates',
		text: 'When there are updates to your assignments.',
	},
	{
		id: 'messages',
		icon: StudentMessagesIcon,
		tone: 'navy',
		title: 'Student messages',
		text: 'When a student sends you a new message.',
	},
]
